import React, {Component} from 'react'
import s from './ProdTickerList.module.css'
import Image from "next/legacy/image"
import { urlFor } from '@lib/sanity'

export interface TListForm {
  icon: any
  content: string
  className: string
}

export interface ProdTickerListProps {
  title?: String
  list?: Array<TListForm>
  className?: String
}

const ProdTickerList: React.FC<ProdTickerListProps> = ((props) => {
  const {
    title,
    list,
    className
  } = props

  return (
    <div className={s.root + ` ${className} ticker_list`}>
        <div className={s.ticker + ` ticker`}>
          {list && list.map((item,index)=>{
            return <div className={s.ticker__item + ` ticker__item px-0 w-e150 mx-16 md:mx-32`} key={index}>
              {item.icon && <div
                className='block w-full relative text-center text-black'>
                <span className={item.icon + ' text-icon32 inline-block text-black'}></span>
                <p className={'text-paragraph01 pt-2'}>{item.content}</p>
              </div>}
            </div>
          })}
          {list && list.map((item,index)=>{
            return <div className={s.ticker__item + ` ticker__item px-0 w-e150 mx-16 md:mx-32`} key={index}>
              {item.icon && <div
                className='block w-full text-center relative  text-black'>
                <span className={item.icon + ' text-icon32 inline-block text-black'}></span>
                <p className={'text-paragraph01 pt-2'} >{item.content}</p>
              </div>}
            </div>
          })}
          {list && list.map((item,index)=>{
            return <div className={s.ticker__item + ` ticker__item  px-0 w-e150 mx-16 md:mx-32`} key={index}>
              {item.icon && <div
                className='block w-full relative text-center text-black'>
                <span className={item.icon + ' text-icon32 inline-block text-black'}></span>
                <p className={'text-paragraph01 pt-2'} >{item.content}</p>
              </div>}
            </div>
          })}
        </div>
    </div>
  )
})

export default ProdTickerList
